import GeneratorInput from "./GeneratorInput";
export default GeneratorInput;
